(() => {
    const header = document.querySelector('.rush-header');
    if (!header || header.dataset.megaMenuReady === 'true') return;
    header.dataset.megaMenuReady = 'true';

    const desktopShop = header.querySelector('[data-desktop-shop]');
    const desktopToggle = desktopShop?.querySelector('.rush-nav__shop-toggle');
    const desktopPanel = desktopShop?.querySelector('[data-desktop-shop-panel]');
    let desktopCloseTimer;

    const setDesktopOpen = (isOpen) => {
      if (!desktopShop || !desktopToggle) return;
      window.clearTimeout(desktopCloseTimer);
      desktopShop.classList.toggle('is-open', isOpen);
      desktopToggle.setAttribute('aria-expanded', String(isOpen));
    };

    const scheduleDesktopClose = () => {
      window.clearTimeout(desktopCloseTimer);
      desktopCloseTimer = window.setTimeout(() => {
        if (!desktopShop?.contains(document.activeElement)) setDesktopOpen(false);
      }, 220);
    };

    desktopToggle?.addEventListener('click', (event) => {
      const isOpen = desktopShop.classList.contains('is-open');
      setDesktopOpen(event.detail === 0 ? !isOpen : true);
    });
    desktopShop?.addEventListener('mouseenter', () => setDesktopOpen(true));
    desktopShop?.addEventListener('mouseleave', (event) => {
      if (desktopPanel?.contains(event.relatedTarget)) return;
      scheduleDesktopClose();
    });
    desktopPanel?.addEventListener('mouseenter', () => setDesktopOpen(true));
    desktopPanel?.addEventListener('mouseleave', (event) => {
      if (desktopShop?.contains(event.relatedTarget)) return;
      scheduleDesktopClose();
    });
    desktopShop?.addEventListener('focusin', () => setDesktopOpen(true));
    desktopShop?.addEventListener('focusout', (event) => {
      if (!desktopShop.contains(event.relatedTarget)) setDesktopOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (desktopShop && !desktopShop.contains(event.target)) setDesktopOpen(false);
    });
    desktopShop?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setDesktopOpen(false);
        desktopToggle.focus();
      }
    });

    document.querySelectorAll('[data-mobile-shop-toggle]').forEach((toggle) => {
      if (toggle.closest('[data-mobile-shop]')?.closest('#RushMobileMenu') === null) return;
      toggle.addEventListener('click', () => {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        const isOpen = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(isOpen));
        if (panel) panel.hidden = !isOpen;
      });
    });
  })();
